<div class="adminContainer">
    <div class="adminHeader">
        <app-header-admin></app-header-admin>
    </div>
    <div class="adminCenterContainer">
        <router-outlet></router-outlet>
    <footer class="adminFooter">
        <app-footer-admin></app-footer-admin>
    </footer>
 </div>
</div>
    